import { Method, AxiosRequestHeaders } from "axios";
import { getAccessToken, logout } from "./Auth";
import clientTokenHelper from "./ClientTokenHelper";
import { BaseHttpService } from "./BaseHttpService";

const RETRY_LIMIT = 3;

const UNAUTHORIZED_CODE = 401;

export default abstract class AuthHttpService extends BaseHttpService {

  protected constructor (readonly url?: string) {
    super(url);
  }

  protected async request(method: Method, url: string, data?: any, headers?: AxiosRequestHeaders, retry?: number): Promise<any> {
    const userToken: string | null = await getAccessToken();
    const clientToken: string | null = userToken === null ? await clientTokenHelper.get() : null;
    const token = userToken || clientToken;

    const requestHeaders: AxiosRequestHeaders = headers || {};

    if (token !== null) {
      requestHeaders["Authorization"] = `Bearer ${token}`;
    }

    return super.request(method, url, data, requestHeaders)
      .catch(reason => {
        const requestRetry = retry || 1;

        if (requestRetry < RETRY_LIMIT && reason.response?.status === UNAUTHORIZED_CODE) {
          if (clientToken !== null) {
            clientTokenHelper.reset();
            return this.request(method, url, data, headers, requestRetry + 1);
          }

          if (userToken !== null) {
            logout();
          }
        }

        return Promise.reject(reason);
      });
  }
}
